import React from 'react'
import { BottleneckEstimatedImpact } from './bottleneck-estimated-impact'
import { BottleneckRelatedSpans } from './bottleneck-related-spans'
import { BottleneckRelatedCalls } from './bottleneck-related-calls'
import { BottleneckDescription } from './bottleneck-description'
import { BottleneckMessage } from '../domain/BottleneckMessage'
import { TimelineSpan } from '../domain/TimelineSpan'

type Props = {
    type: string
    message: BottleneckMessage
    spans?: TimelineSpan[]
    routes?: {
        clickRoute: string
        callgraphRoute: string
        timelineRoute: string
    }
}

/**
 * Displays the UI for a bottleneck: the server side rendered markdown description plus the shared
 * impact / related calls / related spans widgets.
 */
export const BottleneckView: React.FunctionComponent<Props> = ({ message, type, spans, routes }) => {
    return (
        <>
            <BottleneckEstimatedImpact message={message} />
            <BottleneckDescription message={message} />
            <BottleneckRelatedCalls routes={routes} message={message} />
            <BottleneckRelatedSpans type={type} spans={spans} routes={routes} />
        </>
    )
}
